/**
 * Persistence Layer Exports
 * Singleton factories for repository instances
 */

import { ClerkAuthRepository } from './clerk/ClerkAuthRepository';
import type { IAuthRepository } from './interfaces/IAuthRepository';

// Singleton instances
let authRepoInstance: IAuthRepository | null = null;

/**
 * Get or create auth repository instance
 * Note: The Clerk instance will be set by AuthContext after ClerkProvider is mounted
 */
export function createAuthRepository(): IAuthRepository {
  if (!authRepoInstance) {
    authRepoInstance = new ClerkAuthRepository();
  }
  return authRepoInstance;
}

// Re-export interfaces
export type { IAuthRepository } from './interfaces/IAuthRepository';
